import { ValueOf } from '@wix/document-services-types';
import { LAYOUT } from '@wix/component-protocol/schema';

import type {
  EditorPointer,
  CompPointer,
} from '@wix/editor-document-logic-api';

export const PLATFORM_BREAKPOINT_RANGES: BreakpointRange[] = [
  {
    min: 1024,
    size: LAYOUT.BREAKPOINT.large,
  },
  {
    min: 0,
    size: LAYOUT.BREAKPOINT.small,
    max: 1023,
  },
];

export type Breakpoint = Exclude<
  ValueOf<typeof LAYOUT.BREAKPOINT>,
  typeof LAYOUT.BREAKPOINT.UNKNOWN_Breakpoint
>;

export type BreakpointRange = {
  size: Breakpoint;
  min: number;
  max?: number;
};

export type EditorPlatformHostAPIStage = {
  getBreakpointFromPointer: (
    editorPointer: EditorPointer,
    breakpointRanges: BreakpointRange[],
  ) => Breakpoint | null;

  /**
   * Get an EditorPointer that represents the given component in the current breakpoint context.
   * @param editorPointer The base EditorPointer
   * @returns EditorPointer representing the component in the current breakpoint context
   */
  getPointerWithCurrentVariants: (
    editorPointer: EditorPointer,
  ) => EditorPointer<CompPointer>;

  /**
   * Get an EditorPointer that represents the given component in the given breakpoint context.
   * @param editorPointer The base EditorPointer
   * @param breakpointRange The breakpoint range to get the variant for
   * @returns EditorPointer representing the component in the given breakpoint context
   */
  getPointerWithBreakpointVariant: (
    editorPointer: EditorPointer,
    breakpointRange: BreakpointRange,
  ) => EditorPointer<CompPointer>;
};
